import moment from "moment";
import scheduleStatusPresentationMethods from "@/controllers/scheduleStatusPresentationMethods";
import createManagementScheduleDateMethods from "@shared/createManagementScheduleDateMethods.cjs";

const scheduleDateMethods = createManagementScheduleDateMethods({
  DateFormatter: moment,
  Window: window,
});

const BOOKING_TYPE_LABELS = {
  direct: "온라인",
  estimate: "견적",
  phone: "전화",
  offline: "오프라인",
};

export default {
  ...scheduleDateMethods,
  ...scheduleStatusPresentationMethods,
  bookingTypeLabel(type) {
    return BOOKING_TYPE_LABELS[type] || type || "-";
  },
};
